import Constants from "../helpers/Constants";

export const GA_TRACKING_ID = "AW-665740217";

// 우진 (2026-05-06): 기존엔 gtag("config", ...)로 page_view를 발사했는데,
// 이 방식은 GTM의 "Google 태그" 기본 page_view와 중복됨. GTM이 이미
// PAGE_VIEW_LOADED 커스텀 이벤트 트리거의 ga4_page_view 태그를 가지고
// 있으므로, SPA 라우트 변경 시엔 dataLayer에 PAGE_VIEW_LOADED 이벤트만
// 푸시하면 됨. (Google 태그는 PAGE_VIEW_LOADED를 EXCEPTION으로 제외하고
// 있어서 중복 발사되지 않음.)
export const pageview = url => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "PAGE_VIEW_LOADED",
    page_path: window.location.pathname,
    page_location: url || window.location.href,
    page_title: document.title,
  });
};

export const landingButtonPress = url => {
  var callback = function() {
    if (typeof url != "undefined") {
      window.location = url;
    }
  };
  if (url === Constants.SIGNUP_URL) {
    window.gtag("event", "conversion", {
      send_to: "AW-665740217/DGFhCLT7h8UBELnHub0C",
      event_callback: callback
    });
    return false;
  }
  if (url === "growing-sales/pos") {
    window.gtag("event", "conversion", {
      send_to: "AW-665740217/dGx1CM_v98gBELnHub0C",
      event_callback: callback
    });
    return false;
  }
  if (url === "store") {
    window.gtag("event", "conversion", {
      send_to: "AW-665740217/jPy6CNP2gskBELnHub0C",
      event_callback: callback
    });
    return false;
  }
};

export const tryPurchase = url => {
  window.gtag("event", "conversion", {
    send_to: "AW-665740217/vgLcCKvn6cgBELnHub0C",
    transaction_id: ""
  });
};
